import { TablePagination } from '@octano/global-ui';
import { useStudentsRemovalRequestsPendingtList } from './StudentsRemovalRequestsPendingListLoader';

export interface PerformanceAnalysisTablePaginationProps {
  total: number;
  totalPages: number;
}

export function StudentsRemovalRequestsPendingTablePagination({
  total,
  totalPages,
}: PerformanceAnalysisTablePaginationProps) {
  const { query, updateQuery } = useStudentsRemovalRequestsPendingtList();

  return (
    <TablePagination
      pagination={{
        currentPage: query.page,
        itemsPerPage: 10,
        onChangePage: (page) => {
          updateQuery({ ...query, page });
        },
        totalItems: total,
        totalPages: totalPages,
      }}
    />
  );
}
